var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 0C3.98062 0 0.710632 3.26998 0.710632 7.28938C0.710632 8.9479 1.25415 10.5099 2.28245 11.8064C3.61389 13.4851 7.48579 17.4711 7.64994 17.6399L7.99996 18L8.35004 17.64C8.51428 17.471 12.3873 13.4842 13.719 11.8049C14.7464 10.5094 15.2894 8.948 15.2894 7.28938C15.2894 3.26998 12.0194 0 8.00001 0ZM12.9539 11.1982C11.8819 12.55 9.00297 15.5572 8.00001 16.5973C6.99715 15.5572 4.11928 12.5509 3.04753 11.1996C2.15755 10.0774 1.68713 8.72531 1.68713 7.28938C1.68713 3.80842 4.51906 0.976494 8.00001 0.976494C11.4809 0.976494 14.3129 3.80842 14.3128 7.28938C14.3128 8.72541 13.8429 10.0771 12.9539 11.1982Z",
    fill: "#05BB8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 2.89355C5.62079 2.89355 3.68518 4.82916 3.68518 7.20839C3.68518 9.58761 5.62083 11.5232 8.00001 11.5232C10.3792 11.5232 12.3148 9.58757 12.3148 7.20839C12.3148 4.82921 10.3792 2.89355 8.00001 2.89355ZM8.00001 10.5467C6.15922 10.5467 4.66167 9.04913 4.66167 7.20839C4.66167 5.3676 6.15927 3.87005 8.00001 3.87005C9.84075 3.87005 11.3383 5.36765 11.3383 7.20839C11.3383 9.04918 9.8408 10.5467 8.00001 10.5467Z",
    fill: "#05BB8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1ed441acdbc4fa95193f3dd773c05261.svg";
export { ForwardRef as ReactComponent };